<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ (prospectId() ? 'BEARBEITEN' : 'AKQUISEOBJEKT_ERFASSEN') | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form (ngSubmit)="save()" [formGroup]="formGroup" autocomplete="off" class="padding-16 flex flex-column gap-16">
    <div class="work-card flex flex-column gap-12">
      <h2>{{ 'OBJEKTADRESSE' | translate }}</h2>
      <work-ui-button (buttonClick)="useCurrentLocation()"
                      [fullWidth]="true"
                      [loadingState]="locationLoadingState()"
                      iconName="my_location"
                      text="AKTUELLER_STANDORT"
                      variant="secondary" />

      @if (nearbyAddresses().length > 1) {
        <div class="flex flex-column gap-8">
          <p><small class="work-text-color-light">{{ 'STANDORT_ANDERE_ADRESSE_HINWEIS' | translate }}</small></p>
          <div class="work-buttons work-buttons--wrap">
            @for (nearbyAddress of nearbyAddresses(); track nearbyAddress.formattedAddress; let addressIndex = $index) {
              <work-ui-button (buttonClick)="applyNearbyAddress(addressIndex)"
                              [text]="nearbyAddress.street + ' ' + nearbyAddress.streetNumber"
                              [variant]="selectedNearbyAddressIndex() === addressIndex ? 'primary' : 'secondary'"
                              size="small" />
            }
          </div>
        </div>
      }

      <work-ui-address-autocomplete (addressSelected)="applyAddress($event)" />
      <work-ui-input-field formControlName="objectStreet" label="STRASSE" type="text" />
      <div class="work-input__flexbox">
        <work-ui-input-field formControlName="objectZip" inputMode="numeric" label="PLZ" type="text" />
        <work-ui-input-field formControlName="objectCity" label="ORT" type="text" />
      </div>
      <work-ui-input-field formControlName="title"
                           hintMessage="AKQUISEOBJEKT_BEZEICHNUNG_HINWEIS"
                           label="BEZEICHNUNG"
                           type="text" />
    </div>

    <div class="work-card flex flex-column gap-12">
      <h2>{{ 'ANSPRECHPERSON' | translate }}</h2>
      <p><small class="work-text-color-light">{{ 'AKQUISEOBJEKT_ANSPRECHPERSON_HINWEIS' | translate }}</small></p>
      <work-ui-input-field formControlName="company" label="FIRMA" type="text" />
      <work-ui-input-field formControlName="firstName" label="VORNAME" type="text" />
      <work-ui-input-field formControlName="lastName" label="NACHNAME" type="text" />
      <work-ui-input-field formControlName="phone" label="TELEFON" type="tel" />
      <work-ui-input-field formControlName="email" label="EMAIL" type="email" />
    </div>

    <work-ui-button [disabled]="!hasAddress() || formGroup.invalid"
                    [fullWidth]="true"
                    [loadingState]="saveLoadingState()"
                    iconName="check"
                    text="SPEICHERN"
                    type="submit" />
  </form>
</ion-content>
